export default "__VITE_ASSET__d8c58d4f__"